<style lang="less" scoped>
.setting-list{
    padding: 10px;
    margin: 0 auto 30px auto;
}
.setting-list-title{
    font-size: 18px;
    line-height: 40px;
    font-weight: bold;
    border-bottom: 1px solid #ececec;
}
/deep/.el-form-item__content{
    width: 280px!important;
}
.save-btn{
    margin: 30px 0 10px 0;
    text-align: center;
}
.setting-content{
  padding: 20px 50px;
}
</style>
<template>
  <div>
    <div class="page-main">
      <div class="page-main-top">
        <div class="page-content">
            <div class="title">报警设置</div>
            <div class="content" v-loading="pageLoading">
                <el-form label-width="280px" :rules="rules" :model="ruleForm" ref="ruleForm">
                    <div class="setting-list" v-for="(item,index) in alarmList" :key="index">
                        <div class="setting-list-title font-color-theme">{{item.station_name}}</div>
                        <div class="setting-content">
                          <el-collapse v-model="activeNames" @change="handleChange">
                            <el-collapse-item  v-for="(list,i) in item.device_settings" :title="list.device_name" :key="i" :name="item.station_name+list.device_name+i">
                              <el-row class="mt-30">
                                <el-col :span="24" v-for="(alarm,z) in list.alarm_settings" :key="z">
                                    <el-form-item :label="alarm.alarm_field_title" prop="">
                                        <el-input placeholder="请输入" v-model="alarm.alarm_value"></el-input>
                                    </el-form-item>
                                </el-col>
                              </el-row>
                            </el-collapse-item>
                            
                          </el-collapse>
                        </div>
                        
                        <!-- <el-row>
                            <el-col :span="12" v-for="(list,i) in item.alarm_settings" :key="i">
                                <el-form-item :label="list.alarm_field_title" prop="">
                                    <el-input placeholder="请输入" v-model="list.alarm_value"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row> -->
                    </div>
                    <div class="save-btn">
                        <el-button
                            class="subbtn"
                            @click="saveSeting()"
                            type="primary"
                            :loading="submitBtn.isBtnLoading"
                            :disabled="submitBtn.isDisabled"
                            >{{ submitBtn.btnText }}</el-button
                    >
                    </div>
                </el-form>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "alarmSetting", //警报设置

  data() {
    return {
      pageLoading: false, //页面loading
      activeNames:[],
      submitBtn: {
        btnText: "保存设置",
        isLoading: false,
        isDisabled: false
      },
      rules:{},
      ruleForm:{},
      alarmList:[]
    };
  },
  computed: {},
  methods: {
    getSetting() {
      this.pageLoading = true;
      this.$$http("alarmSetting", {})
        .then(results => {
          this.pageLoading = false;
          if (results.data && results.status == 200) {
            console.log('消息',results.data);
            this.alarmList = results.data;
          }
        })
        .catch(err => {
          this.pageLoading = false;
        });
    },
    handleChange(val) {
      console.log(val);
    },
    saveSeting(){
        let list = [];
        let isSave = true;
        for(let i in this.alarmList){
            this.alarmList[i].device_settings.map((device)=>{
              device.alarm_settings.map((alarm)=>{
                if(!alarm.alarm_value){
                    // console.log('不能为空')
                    this.$message.error(device.device_name+alarm.alarm_field_title+'值不能为空');
                    isSave = false;
                }else{
                    list.push({
                        id:alarm.id,
                        alarm_value:alarm.alarm_value
                    })
                }
              })
            })
          
            // for(let j in this.alarmList[i].alarm_settings){
            //     if(!this.alarmList[i].alarm_settings[j].alarm_value){
            //         console.log('不能为空')
            //         this.$message.error(this.alarmList[i].alarm_settings[j].alarm_field_title+'值不能为空');
            //         return false;
            //     }else{
            //         list.push({
            //             id:this.alarmList[i].alarm_settings[j].id,
            //             alarm_value:this.alarmList[i].alarm_settings[j].alarm_value
            //         })
            //     }
            // }
        }
          // console.log('继续',isSave)
        if(isSave){
          this.$$http("updateAlarmSetting",{
              settings:list
          }).then(results => {
            this.submitBtn.pageLoading = false;
            if (results.data && results.status == 200) {
                this.$message.success('保存成功');
              this.getSetting();
            }
          })
          .catch(err => {
            this.submitBtn.pageLoading = false;
          });
        }
        
    }
 },
  created() {
      this.getSetting();
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/giveAnAlarm/alarmSetting.vue